// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_GENERIC_STAFF_LIST_REQUEST_SUCCESS,
  GET_GENERIC_STAFF_LIST_REQUEST_ERROR,
  GET_GENERIC_STAFF_LIST_REQUEST,
} from "../../constants";
import axios from "../../../../services/api";

function* getStaffList(data) {
  try {
    const params = new URLSearchParams();

    if (data.ordering) {
      params.append("ordering", data.ordering);
    }
    if (data.searchItem) {
      params.append("search", data.searchItem);
    }
    if (data.page) {
      params.append("page", data.page);
    }
    const response = yield call(axios.get, `/generic-staff`, { params });
    if (response.data.error) {
      yield put({
        type: GET_GENERIC_STAFF_LIST_REQUEST_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_GENERIC_STAFF_LIST_REQUEST_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_GENERIC_STAFF_LIST_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function* getStaffListSaga() {
  yield takeLatest(GET_GENERIC_STAFF_LIST_REQUEST, getStaffList);
}
